import { render, staticRenderFns } from "./GalleryViewButtons.vue?vue&type=template&id=1f9fb720&scoped=true"
import script from "./GalleryViewButtons.vue?vue&type=script&lang=js"
export * from "./GalleryViewButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fb720",
  null
  
)

export default component.exports